import { Injectable, CommonFeatures } from "bwtk";
const { BaseConfig, configProperty } = CommonFeatures;

@Injectable
export class Config extends BaseConfig<Config> {
  @configProperty
  lang: string;

  @configProperty
  url: string;

  @configProperty
  localizationUrl: string;

  @configProperty
  brand: string;

  @configProperty
  brandStyle: string;

  @configProperty
  token: string;

  @configProperty
  supportEmail: string;

  @configProperty
  supportPhone: string;

  @configProperty
  supportTTYPhone: string;

  @configProperty
  siteKey: string;

  @configProperty
  recaptchaValidationUrl: string;

  @configProperty
  recaptchaClientId: number;

  @configProperty
  recaptchaText: string;

  @configProperty
  isDebugMode: boolean;

  @configProperty
  isRecaptchaOn: boolean;

  @configProperty
  isProd: boolean;
}